import { useEffect, useState } from 'react'
import { Summary } from '@/components/sections/cv/Summary'
import { Experience } from '@/components/sections/cv/Experience'
import { ToolsDaily } from '@/components/sections/cv/ToolsDaily'
import { Community } from '@/components/sections/cv/Community'
import { References } from '@/components/sections/cv/References'
import { AboutValues } from '@/components/sections/cv/AboutValues'
import { AboutLearning, AboutTools } from '@/components/sections/cv/AboutLearning'
import { Connect } from '@/components/sections/portfolio'
import { SEO } from '@/components/shared/SEO'
import { identity } from '@/content/portfolio'
import LetterGlitch from '@/components/ui/LetterGlitch'
import { useReducedMotion } from '@/lib/useReducedMotion'
import './About.css'

export function About() {
  const reducedMotion = useReducedMotion()
  const [lightMode, setLightMode] = useState(() => document.documentElement.dataset.theme === 'light')

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setLightMode(document.documentElement.dataset.theme === 'light')
    })
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
    return () => observer.disconnect()
  }, [])

  return (
    <>
      <SEO title="About — Will Tran" description="My path from software engineering to technical product management and product leadership. Experience, working principles, community, and references." url={`${identity.website}/about`} />
      <main id="main-content" tabIndex={-1} className="about-page relative isolate pt-20">
        <div aria-hidden="true" className="about-background pointer-events-none fixed inset-0 -z-10">
          <LetterGlitch
            key={String(reducedMotion)}
            lightMode={lightMode}
            glitchAmount={0.5}
            speed={reducedMotion ? 0 : 1}
            flow={0.5}
            clickEffect="tear"
            centerFade={0.65}
            edgeFade={0.05}
          />
        </div>
        <Summary />
        <AboutValues />
        <Experience />
        <References compact />
        <AboutLearning />
        <Community />
        <details className="border-t border-vibe-border">
          <summary className="mx-auto max-w-6xl cursor-pointer px-5 py-8 text-lg text-text-heading lg:px-8">A closer look at my AI-assisted workflows</summary>
          <ToolsDaily />
        </details>
        <AboutTools />
        <Connect />
      </main>
    </>
  )
}
